import React from 'react';
import { useTranslation } from 'react-i18next';
import PreviewTitle from '../../previewTitle/previewTitle';

const SuPaymentMethodPreview = () => {
	const { t } = useTranslation();

	return (
		<div data-testid="su-payment-method-preview">
			<PreviewTitle size="two">{t('payment_method.su_payment_methods.label')}</PreviewTitle>
		</div>
	);
};

export default SuPaymentMethodPreview;
